<template>
  <BaseTableView :head="tableHead" :sticky="false">
    <EmployeesGroupSelectTableItem v-for="(item, key) in items" :key="key" :item="item" />
  </BaseTableView>
</template>

<script>
import EmployeesGroupSelectTableItem from './EmployeesGroupSelectTableItem'
export default {
  name: 'EmployeesGroupSelectTable',
  props: { items: Array },
  components: { EmployeesGroupSelectTableItem },
  data() {
    return {
      tableMin: false,
    }
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'familiya-imya'
          ],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'dolzhnost'
          ],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'status-sotrudnika'
          ],
        },
      ]
    },
  },
}
</script>
